import { shouldTrack } from '$lib/global/tracking/helper';

import { getQueue, SEND_TIMEOUT_MS, send } from './queue';

interface TrackingPayload {
    type?: string;
    event?: string;
    name?: string;
    traits?: Record<string, unknown>;
    properties?: Record<string, unknown>;
    [key: string]: unknown;
}

export const track = (data: TrackingPayload) => {
    return enqueue('/t', { ...data, type: 'track' });
};

export const page = (data: TrackingPayload) => {
    return enqueue('/p', { ...data, type: 'page' });
};

export const identify = (data: TrackingPayload) => {
    return enqueue('/i', { ...data, type: 'identify' });
};
export const enqueue = (path: string, message: TrackingPayload) => {
    if (!shouldTrack()) {
        return;
    }

    const url = `/ps-fnl-events/api/data${path}`;

    const queue = getQueue();

    send(
        message,
        url,
        (err: { status: string; responseText: string }) => {
            if (err) {
                const lastPart = url.split('/').reverse()[0];
                console.warn(`Direct Tracking Error: /${lastPart} - ${err.status}`, {
                    data: {
                        url,
                        message,
                        error: JSON.stringify(err),
                        status: err.status,
                        responseText: err.responseText,
                    },
                });

                // On failure, add to the queue for retry.
                queue.addItem({
                    url,
                    message,
                });
            }
        },
        SEND_TIMEOUT_MS,
    );
};

export default {
    track,
    page,
    identify,
};
